import { computed, ref, onMounted } from 'vue'
import StafetHeader from '../StafetHeader/StafetHeader.vue'
import StafetDeltagPaaHoldStepOne from '../StafetDeltagPaaHoldStepOne/StafetDeltagPaaHoldStepOne.vue'
import StafetDeltagPaaHoldStepTwo from '../StafetDeltagPaaHoldStepTwo/StafetDeltagPaaHoldStepTwo.vue'
import StafetDeltagPaaHoldStepThree from '../StafetDeltagPaaHoldStepThree/StafetDeltagPaaHoldStepThree.vue'
import StafetDeltagPaaHoldStepFour from '../StafetDeltagPaaHoldStepFour/StafetDeltagPaaHoldStepFour.vue'
import FormStepSubmitting from '../FormStepSubmitting/FormStepSubmitting.vue'
import { useStore } from 'vuex'
import mapStafetHeaderSteps from 'foundation/js/stafet/mapStafetHeaderSteps'
import sessionStorageIdentifierEnum from 'foundation/js/sessionStorageWrapper/sessionStorageIdentifierEnum'
import clearItemFromStorage from 'foundation/js/sessionStorageWrapper/clearItemFromStorage'
import getCommonComputedFields from 'foundation/js/stafet/getCommonComputedFields'
import stepsConfig from './config/stepsConfig'
import fieldValidator from 'foundation/js/stafet/fieldValidator'
import updateItemFromStorage from 'foundation/js/sessionStorageWrapper/updateItemFromStorage'
import updateBasket from './methods/updateBasket'
import { scrollToFirstError } from '../../foundation/js/inputValidators/scrollToFirstError'

export default {
    name: 'StafetDeltagPaaHoldFlow',
    components: {
        StafetHeader,
        StafetDeltagPaaHoldStepOne,
        StafetDeltagPaaHoldStepTwo,
        StafetDeltagPaaHoldStepThree,
        StafetDeltagPaaHoldStepFour,
        FormStepSubmitting
    },
    props: {
        stafetId: {
            type: String,
            required: true
        },
        holdId: {
            type: String,
            required: false
        },
        tshirtSizes: {
            type: Array,
            required: true,
            default: []
        },
        holdList: {
            type: Array,
            required: true,
            default: []
        },
        donationAmounts: {
            type: Array,
            required: true,
            default: []
        },
        redirectToEditProfile: {
            type: String,
            required: false,
            default: ''
        },
        editProfileLinkText: {
            type: String,
            required: false,
            default: ''
        },
        lysposeMinimumAmount: {
            type: Number,
            required: false,
            default: 50
        },
        userData: {
            type: Object,
            required: false,
            default: {}
        },
        adultPrice: {
            type: Number,
            required: true
        },
        childPrice: {
            type: Number,
            required: true
        },
        lysposeQuantityOption1: {
            type: Number,
            required: true,
        },
        lysposeQuantityOption2: {
            type: Number,
            required: true,
        },
        lysposeQuantityOption3: {
            type: Number,
            required: true,
        },
        loggedIn: {
            type: Boolean,
            required: true,
        },
    },
    setup(props) {
        const store = useStore()
        const displayInputError = ref(false)

        const labels = computed(() => {
            return store.state.labels.collections['SFLJoinHoldLabels']
        })

        const headerSteps = computed(() => {
            return mapStafetHeaderSteps(
                steps.value,
                currentStep.value,
                labels.value
            )
        })


        const isSubmitting = computed(() => {
            return store.state.stafet.isSubmitting
        })

        const { userInputs, steps, currentStep, currentStepName } =
            getCommonComputedFields(store.state.stafet)

        onMounted(() => {
            store.dispatch('stafet/stafetId', { stafetId: props.stafetId })
            store.dispatch('stafet/steps', {
                steps: stepsConfig
            })
        })

        const handleStepCompleted = () => {
            steps.value.find(
                (item) => item.step === currentStep.value
            ).completed = true

            store.dispatch('stafet/steps', {
                steps: steps.value
            })

            const unCompletedSteps = steps.value.filter(
                (item) => !item.completed
            )

            if (unCompletedSteps.length > 0) {
                store.dispatch('stafet/currentStep', {
                    step: unCompletedSteps[0].step
                })
            }
        }

        const nextStepCallback = (fields) => {
            fields.forEach((field) => {
                if (field.dependentField) {
                    const dependentField = fields.find(
                        (item) => item.name === field.dependentField
                    )

                    if (dependentField) {
                        field.dependentFieldValue = dependentField.value
                    }
                }
                fieldValidator(field)
            })

            const isStepValid = fields.every((field) => field.isValid)
            if (isStepValid) {
                displayInputError.value = false
                handleStepCompleted()
                store.dispatch('stafet/userInputs', { inputs: fields })
                updateItemFromStorage(
                    sessionStorageIdentifierEnum.STAFET_JOIN_A_TEAM,
                    fields
                )
                updateBasket(
                    userInputs.value,
                    labels.value,
                    store,
                    props.adultPrice,
                    props.childPrice
                )

                scrollTo(0, 0)
            } else {
                displayInputError.value = true
                scrollToFirstError()
            }
        }

        const skipStepCallback = () => {
            handleStepCompleted()
        }

        const previousStepCallback = () => {
            if (currentStep.value > 1) {
                store.dispatch('stafet/currentStep', {
                    step: currentStep.value - 1
                })

                steps.value.find(
                    (item) => item.step === currentStep.value
                ).completed = false

                store.dispatch('stafet/steps', {
                    steps: steps.value
                })

                scrollTo(0, 0)
            }
        }

        const submitCallback = async () => {
            // it expects a object with ok: true or false
            await store.dispatch('stafet/joinATeamSubmit')
            return 'submitted'
        }

        return {
            headerSteps,
            labels,
            currentStepName,
            displayInputError,
            isSubmitting,
            nextStepCallback,
            previousStepCallback,
            submitCallback,
            skipStepCallback
        }
    }
}
